class TSMainProduct extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.querySelector("#TSProductForm");
    this.productMessage = this.productForm.querySelector("#TSFormMessage");
    this.mainSliderElement = this.querySelector("#TSMainSlider");
    this.media = this.mainSliderElement.querySelectorAll(
      ".ts-product__media img",
    );
    this.thumbSliderElement = this.querySelector("#TSThumbSlider");
    this.lightboxElement = this.querySelector("#TSLightbox");
    this.mainSlider;
    this.thumbSlider;
    this.lightboxSlider;
    this.cart = document.querySelector("ts-cart");
    this.isLoading = false;
    this.contactForm = this.querySelector(".ts-invoice-form");

    this.initSlider();
    this.initClickEvents();
    this.initSubmitEvents();
    this.initForm();
    this.setupVariantSelector();
    this.initStickyCart();
    this.initBtnPriceListeners();
    this.initCopyCode();
    this.initPopularExtras();
    this.initUgc();
    this.initBundleDeal();

    this.querySelectorAll('[data-trigger="disclosure"].open').forEach(
      (disclosure) => {
        const disclosureContent = disclosure.nextElementSibling;
        disclosureContent.style.maxHeight =
          disclosureContent.scrollHeight + "px";
      },
    );

    this.querySelectorAll(".ts-show-more").forEach((button) => {
      let maxHeight = 240;
      const disclosure = button.closest(".ts-product-info__description");
      if (window.matchMedia("(max-width: 744px)").matches) {
        maxHeight = 340;
      }
      if (disclosure.scrollHeight < maxHeight) {
        button.style.dispaly = "none";
      }

      button.addEventListener("click", () => {
        if (disclosure.classList.contains("open")) {
          disclosure.style.maxHeight = maxHeight + "px";
          disclosure.style.paddingBottom = 0;
        } else {
          disclosure.style.maxHeight = disclosure.scrollHeight + 80 + "px";
          disclosure.style.paddingBottom = 80 + "px";
        }
        disclosure?.classList.toggle("open");
      });
    });

    document.addEventListener("keydown", (e) => {
      if (
        this.lightboxSlider &&
        this.lightboxElement.classList.contains("open")
      ) {
        if (e.key === "ArrowLeft") {
          this.lightboxSlider.previous();
        } else if (e.key === "ArrowRight") {
          this.lightboxSlider.next();
        }
      }
    });
  }

  initSlider() {
    if (this.mainSliderElement?.querySelector("[data-slider]")) {
      this.mainSlider = new Flickity(
        this.mainSliderElement.querySelector("[data-slider]"),
        {
          cellAlign: "left",
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
        },
      );
    }

    if (this.thumbSliderElement?.querySelector("[data-slider]")) {
      this.thumbSlider = new Flickity(
        this.thumbSliderElement.querySelector("[data-slider]"),
        {
          cellAlign: "left",
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
        },
      );

      this.thumbSlider.on(
        "staticClick",
        (event, pointer, cellElement, cellIndex) => {
          if (!cellElement) return;
          this.mainSlider.select(cellIndex);
        },
      );
      this.mainSlider.on("change", (index) => {
        this.thumbSlider.select(index);
      });
    }

    this.initGalleryControls();

    if (this.lightboxElement?.querySelector("[data-lightbox-slider]")) {
      this.lightboxSlider = new Flickity(
        this.lightboxElement.querySelector("[data-lightbox-slider]"),
        {
          cellAlign: "center",
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          draggable: false,
        },
      );
      this.lightboxSlider.on("change", (index) => {
        this.lightboxElement
          .querySelector(".ts-lightbox__thumbnail-item.active")
          .classList.remove("active");
        this.lightboxElement
          .querySelector(
            `.ts-lightbox__thumbnail-item[data-slide="${index + 1}"]`,
          )
          .classList.add("active");
      });
    }
  }

  initGalleryControls() {
    if (!this.mainSlider || !this.thumbSliderElement) return;
    const prevControl = this.thumbSliderElement.querySelector(
      '[data-trigger="previous-slide"]',
    );
    const nextControl = this.thumbSliderElement.querySelector(
      '[data-trigger="next-slide"]',
    );
    if (!prevControl || !nextControl) return;

    const updateControls = () => {
      const index = this.mainSlider.selectedIndex;
      const lastIndex = this.mainSlider.slides.length - 1;
      prevControl.classList.toggle(
        "ts-product__gallery-control--hidden",
        index === 0,
      );
      nextControl.classList.toggle(
        "ts-product__gallery-control--hidden",
        index === lastIndex,
      );
    };

    this.mainSlider.on("select", updateControls);
    updateControls();
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        switch (e.target.dataset.trigger) {
          case "lightbox-change":
            this.lightboxSlider.select(parseInt(e.target.dataset.slide) - 1);
            if (this.querySelector("#TSLightboxHeader")) {
              this.querySelector("#TSLightboxHeader").innerText =
                e.target.dataset.slide +
                " of " +
                this.lightboxSlider.slides.length;
            }
            break;
          case "lightbox-prev":
            this.lightboxSlider.previous();
            break;
          case "lightbox-next":
            this.lightboxSlider.next();
            break;
          case "lightbox-close":
            this.lightboxElement.classList.remove("open");
            break;
          case "lightbox-open":
            if (this.lightboxSlider) {
              this.lightboxSlider.select(parseInt(e.target.dataset.slide) - 1);
              this.querySelector("#TSLightboxHeader").innerText =
                e.target.dataset.slide +
                " of " +
                this.lightboxSlider.slides.length;
            }
            this.lightboxElement.classList.add("open");
            break;
          case "previous-slide":
            if (this.mainSlider) this.mainSlider.previous();
            break;
          case "next-slide":
            if (this.mainSlider) this.mainSlider.next();
            break;
          case "video":
            const videoBlock = e.target;
            const video = e.target.querySelector("video");

            videoBlock.classList.toggle("play");
            if (videoBlock.classList.contains("play")) {
              video.play();
            } else {
              video.pause();
            }
            break;
          case "disclosure":
            const disclosureContent = e.target.nextElementSibling;
            e.target.classList.toggle("open");
            disclosureContent.style.maxHeight = e.target.classList.contains(
              "open",
            )
              ? disclosureContent.scrollHeight + "px"
              : null;
            break;
          case "form":
            this.toggleForm();
            break;
          default:
            break;
        }
      }
    });
  }

  initForm() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("contact_posted") === "true") {
      this.toggleForm();
    }
  }

  toggleForm() {
    this.contactForm.classList.toggle("open");
    if (this.contactForm.classList.contains("open")) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
    }
  }

  initSubmitEvents() {
    this.productForm.addEventListener("submit", (e) => {
      e.preventDefault();
      if (!this.isLoading) this.addToCart();
    });
  }

  setupVariantSelector() {
    const optionInputs = this.querySelectorAll(
      '.ts-options input[type="radio"]',
    );
    const productIdInput = this.querySelector('input[name="id"]');

    if (!productIdInput) return;
    const variantDataScript = this.querySelector("#ProductVariants");
    if (!variantDataScript) return;
    const variants = JSON.parse(variantDataScript.textContent);

    optionInputs.forEach((input) => {
      input.addEventListener("change", () => {
        this.updateVariant(productIdInput, variants);
      });
    });
  }

  updateVariant(productIdInput, variants) {
    const selectedOptions = [];

    this.querySelectorAll(".ts-options fieldset").forEach((fieldset) => {
      const selectedInput = fieldset.querySelector("input:checked");
      if (selectedInput) {
        selectedOptions.push(selectedInput.value);
      }
    });

    const matchedVariant = variants.find((variant) =>
      variant.options.every((opt, index) => opt === selectedOptions[index]),
    );

    if (matchedVariant.featured_image) {
      const matchedUrl = new URL(
        matchedVariant.featured_image.src,
        window.location.origin,
      );

      Array.from(this.media).forEach((img, index) => {
        const imgUrl = new URL(img.src);
        if (imgUrl.pathname === matchedUrl.pathname) {
          this.mainSlider.select(index);
        }
      });
    }

    if (matchedVariant) {
      productIdInput.value = matchedVariant.id;
      this.updateBtnVariantPrice(matchedVariant);
    }
  }

  addToCart() {
    this.toggleLoading();

    const sections = [];
    if (this.cart) sections.push("ts-cart-drawer");

    const cartData = {
      items: [
        {
          id: parseInt(this.productForm.querySelector("[name='id']").value),
          quantity: parseInt(
            this.productForm.querySelector("[name='quantity']").value,
          ),
        },
        ...this.getPopularExtrasItems(),
      ],
      sections: sections,
      sections_url: window.location.pathname,
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(cartData),
    })
      .then((response) => {
        // 422 (e.g. sold out) is JSON with a description — let it through to
        // the .items check below. Anything else non-OK (429 throttling etc.)
        // is an HTML page: parsing it as JSON would crash with a SyntaxError.
        if (!response.ok && response.status !== 422) {
          if (response.status === 429) {
            throw new Error(
              "Te veel verzoeken achter elkaar — wacht heel even en probeer het opnieuw.",
            );
          }
          throw new Error("Er ging iets mis. Probeer het zo opnieuw.");
        }
        return response.json();
      })
      .then((response) => {
        // Real Shopify error payloads (422 etc.) carry a description/message.
        if (!response.items && (response.description || response.message)) {
          throw new Error(response.description || response.message);
        }

        if (this.productMessage) this.productMessage.innerHTML = "";

        if (!this.cart) {
          window.location.pathname = "/cart";
          return;
        }

        if (response.sections) {
          this.cart.renderContent(response.sections);
          this.cart.open();
          return;
        }

        // No sections in the response: apps that intercept cart requests
        // (Kaching Bundles, intercept_cart_request) swap in their own success
        // payload without our sections. The add itself succeeded (HTTP 2xx),
        // so fetch the drawer section ourselves and open it.
        return fetch(`${window.location.pathname}?sections=ts-cart-drawer`)
          .then((res) => res.json())
          .then((sections) => {
            this.cart.renderContent(sections);
            this.cart.open();
          });
      })
      .catch((error) => {
        if (this.productMessage) {
          this.productMessage.textContent =
            error.message || "Er ging iets mis. Probeer het zo opnieuw.";
          setTimeout(() => {
            this.productMessage.innerHTML = "";
          }, 5000);
        }
        console.error(error);
      })
      .finally(() => {
        this.toggleLoading();
      });
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.remove("loading", this.isLoading);

    // Sync sticky cart button loading state
    const stickyButton = document.querySelector("#StickyProductSubmit");
    const mainButton = this.querySelector("#TSProductSubmit");
    if (stickyButton && mainButton) {
      if (this.isLoading) {
        stickyButton.classList.add("loading");
        stickyButton.disabled = true;
      } else {
        stickyButton.classList.remove("loading");
        stickyButton.disabled = false;
      }
    }
  }
  initPopularExtras() {
    // FC Popular Extras: only active when the block is on the page
    const root = this.querySelector("[data-fc-popular-extras]");
    if (!root) return;

    // Show-more bar toggles the overflow items (show all / show less)
    const showMore = root.querySelector("[data-extra-show-more]");
    if (showMore) {
      const showMoreLabel = showMore.querySelector(
        "[data-extra-show-more-label]",
      );
      const showMoreIcon = showMore.querySelector(
        ".fc-popular-extras__more-icon",
      );
      showMore.addEventListener("click", () => {
        const expand = showMore.getAttribute("aria-expanded") !== "true";
        root.querySelectorAll("[data-extra-item-overflow]").forEach((item) => {
          item.classList.toggle("fc-popular-extras__item--hidden", !expand);
        });
        showMore.setAttribute("aria-expanded", String(expand));
        showMoreLabel.textContent = expand
          ? showMore.dataset.lessLabel
          : showMore.dataset.moreLabel;
        showMoreIcon.textContent = expand ? "–" : "+";
      });
    }

    // Info modal: product title, image slider and description per extra
    const closeExtraModal = (modal) => {
      modal.hidden = true;
      document.documentElement.style.overflow = "";
      const trigger = modal
        .closest("[data-extra-item]")
        .querySelector("[data-extra-info]");
      if (trigger) trigger.focus();
    };

    document.addEventListener("keydown", (e) => {
      const openModal = root.querySelector("[data-extra-modal]:not([hidden])");
      if (!openModal) return;

      if (e.key === "Escape") {
        closeExtraModal(openModal);
        return;
      }

      // Keep focus inside the dialog while it is open
      if (e.key === "Tab") {
        const focusable = openModal.querySelectorAll(
          "button, a[href], [tabindex]:not([tabindex='-1'])",
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    root.querySelectorAll("[data-extra-item]").forEach((item) => {
      const toggle = item.querySelector("[data-extra-toggle]");

      const info = item.querySelector("[data-extra-info]");
      const modal = item.querySelector("[data-extra-modal]");
      if (info && modal) {
        let modalSlider = null;

        // Cap the description at the gallery's height (desktop) or a fixed
        // height (mobile); the show-more button expands it
        const description = modal.querySelector(
          "[data-extra-modal-description]",
        );
        const descriptionMore = modal.querySelector("[data-extra-modal-more]");
        const gallery = modal.querySelector(".fc-popular-extras__modal-gallery");

        const modalContent = modal.querySelector(
          ".fc-popular-extras__modal-content",
        );

        const capDescription = () => {
          if (!description || !descriptionMore) return;
          const isDesktop = window.matchMedia("(min-width: 750px)").matches;
          const cap =
            isDesktop && gallery && gallery.offsetHeight > 0
              ? gallery.offsetHeight
              : 240;
          description.dataset.cap = cap;
          if (descriptionMore.getAttribute("aria-expanded") !== "true") {
            description.style.maxHeight = cap + "px";
          }
          const fits = description.scrollHeight <= cap;
          descriptionMore.hidden = fits;
          modalContent.classList.toggle("fits", fits);
        };

        if (descriptionMore) {
          descriptionMore.addEventListener("click", () => {
            const expand =
              descriptionMore.getAttribute("aria-expanded") !== "true";
            descriptionMore.setAttribute("aria-expanded", String(expand));
            modalContent.classList.toggle("open", expand);
            description.style.maxHeight = expand
              ? description.scrollHeight + "px"
              : description.dataset.cap + "px";
          });
        }

        let trustpilotLoaded = false;

        info.addEventListener("click", () => {
          modal.hidden = false;
          document.documentElement.style.overflow = "hidden";

          const sliderEl = modal.querySelector("[data-extra-modal-slider]");
          if (sliderEl && sliderEl.children.length > 1) {
            if (!modalSlider) {
              // Init on first open — Flickity needs the element visible to measure
              modalSlider = new Flickity(sliderEl, {
                cellAlign: "left",
                contain: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
              });

              const counter = modal.querySelector("[data-extra-modal-counter]");
              if (counter) {
                const total = modalSlider.cells.length;
                const pad = (n) => String(n).padStart(2, "0");
                modalSlider.on("change", (index) => {
                  counter.textContent = pad(index + 1) + "/" + pad(total);
                });
              }
            } else {
              modalSlider.resize();
            }
          }

          // TrustBox widgets inside hidden containers need a re-init once visible
          if (!trustpilotLoaded) {
            trustpilotLoaded = true;
            const trustbox = modal.querySelector(".trustpilot-widget");
            if (trustbox && window.Trustpilot) {
              window.Trustpilot.loadFromElement(trustbox, true);
            }
          }

          capDescription();
          modal.querySelector(".fc-popular-extras__modal-close").focus();
        });

        modal.querySelectorAll("[data-extra-modal-close]").forEach((el) => {
          el.addEventListener("click", () => closeExtraModal(modal));
        });

        const prev = modal.querySelector("[data-extra-modal-prev]");
        const next = modal.querySelector("[data-extra-modal-next]");
        if (prev) {
          prev.addEventListener("click", () => {
            if (modalSlider) modalSlider.previous();
          });
        }
        if (next) {
          next.addEventListener("click", () => {
            if (modalSlider) modalSlider.next();
          });
        }
      }

      // Toggling on shows the variant picker (when the extra has variants)
      toggle.addEventListener("change", () => {
        item.classList.toggle("is-on", toggle.checked);
      });

      // Variant change: point the toggle at the chosen variant + update prices
      item
        .querySelectorAll(".fc-popular-extras__variant-input")
        .forEach((radio) => {
          radio.addEventListener("change", () => {
            if (!radio.checked) return;
            toggle.dataset.variantId = radio.value;

            const price = item.querySelector("[data-extra-price]");
            const current = item.querySelector("[data-extra-current]");
            const compare = item.querySelector("[data-extra-compare]");
            const badge = item.querySelector("[data-extra-badge]");
            const onSale = radio.dataset.compare !== "";

            current.textContent = radio.dataset.price;
            compare.textContent = radio.dataset.compare;
            compare.hidden = !onSale;
            badge.textContent = radio.dataset.discount;
            badge.hidden = !onSale;
            price.classList.toggle("is-sale", onSale);
          });
        });
    });
  }

  initBundleDeal() {
    // FC Bundle Deals: only active when the block is on the page
    const root = this.querySelector("[data-bundle-deal]");
    if (!root) return;

    const toggle = root.querySelector("[data-bundle-deal-toggle]");
    const panel = root.querySelector("[data-bundle-deal-panel]");
    const widgetSlot = root.querySelector("[data-bundle-deal-widget]");
    const titleEl = root.querySelector("[data-bundle-deal-title]");
    const priceEl = root.querySelector("[data-bundle-deal-price]");
    const chipEl = root.querySelector("[data-bundle-deal-chip]");
    const imageEl = root.querySelector("[data-bundle-deal-image]");
    const closeBtn = root.querySelector(".fc-bundle-deal__close");
    const mobile = window.matchMedia("(max-width: 749px)");

    // Mirror the widget's selected bar onto the collapsed FC bar
    const sync = () => {
      const selected =
        widgetSlot.querySelector(".kaching-bundles__bar--selected") ||
        widgetSlot.querySelector(".kaching-bundles__bar:has(input:checked)") ||
        widgetSlot.querySelector(".kaching-bundles__bar");
      if (!selected) return;

      const title = selected.querySelector(".kaching-bundles__bar-title");
      const price = selected.querySelector(".kaching-bundles__bar-price");
      const badge = selected.querySelector(
        ".kaching-bundles__bar-first-line > :not(.kaching-bundles__bar-title)",
      );
      const subtitle = selected.querySelector(".kaching-bundles__bar-subtitle");
      const image = selected.querySelector(
        ".kaching-bundles__bundle-products__image",
      );

      if (title) titleEl.textContent = title.textContent.trim();
      if (price) priceEl.textContent = price.textContent.trim();
      if (image && imageEl) imageEl.src = image.src;

      // Red chip for a discount badge, dark chip for the plain bar's subtitle
      const badgeText = badge ? badge.textContent.trim() : "";
      const subtitleText = subtitle ? subtitle.textContent.trim() : "";
      if (badgeText || subtitleText) {
        chipEl.hidden = false;
        chipEl.textContent = badgeText || subtitleText;
        chipEl.classList.toggle("fc-bundle-deal__chip--sale", !!badgeText);
      } else {
        chipEl.hidden = true;
      }
    };

    const setOpen = (open) => {
      root.classList.toggle("open", open);
      panel.hidden = !open;
      toggle.setAttribute("aria-expanded", String(open));
      if (mobile.matches) {
        document.documentElement.style.overflow = open ? "hidden" : "";
        if (open && closeBtn) closeBtn.focus();
      }
      if (!open) {
        sync();
        toggle.focus({ preventScroll: true });
      }
    };

    toggle.addEventListener("click", () => {
      setOpen(panel.hidden);
    });

    root.querySelectorAll("[data-bundle-deal-close]").forEach((el) => {
      el.addEventListener("click", () => setOpen(false));
    });

    const confirmBtn = root.querySelector("[data-bundle-deal-confirm]");
    if (confirmBtn) confirmBtn.addEventListener("click", () => setOpen(false));

    // Radio changes inside the widget bubble up — keep the bar live
    widgetSlot.addEventListener("change", () => sync());

    document.addEventListener("keydown", (e) => {
      if (panel.hidden) return;

      if (e.key === "Escape") {
        setOpen(false);
        return;
      }

      // Keep focus inside the sheet while it is open (mobile dialog)
      if (e.key === "Tab" && mobile.matches) {
        const focusable = panel.querySelectorAll(
          "button, a[href], input, select, [tabindex]:not([tabindex='-1'])",
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    // The Kaching app embed injects <kaching-bundle> near the product form
    // at its own pace (Vue, async). Adopt it into the panel once its bars
    // exist; the app's cart-request interceptor is fetch-level, so moving
    // the element does not affect how the main ATC adds the bundle.
    const adopt = () => {
      const widget = document.querySelector("kaching-bundle");
      if (!widget || !widget.querySelector(".kaching-bundles__bar")) {
        return false;
      }
      if (!widgetSlot.contains(widget)) widgetSlot.appendChild(widget);
      root.classList.remove("fc-bundle-deal--loading");
      toggle.disabled = false;
      sync();
      return true;
    };

    if (!adopt()) {
      const observer = new MutationObserver(() => {
        if (adopt()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });

      // No widget for this product (app off / product not selected in
      // Kaching): remove the block so the body:has() rule stops hiding
      // any widget that might still arrive later
      setTimeout(() => {
        if (!root.classList.contains("fc-bundle-deal--loading")) return;
        observer.disconnect();
        root.remove();
      }, 10000);
    }
  }

  // Toggled-on extras ride along with the main product in the same
  // cart/add.js call — no separate add-to-cart button
  getPopularExtrasItems() {
    const items = [];
    this.querySelectorAll("[data-extra-toggle]:checked").forEach((toggle) => {
      items.push({ id: parseInt(toggle.dataset.variantId, 10), quantity: 1 });
    });
    return items;
  }

  initUgc() {
    // FC UGC Media: only active when the block is on the page
    const root = this.querySelector("[data-fc-ugc]");
    if (!root) return;

    const track = root.querySelector("[data-fc-ugc-track]");
    const cells = track.children.length;

    let slider = null;
    if (cells > 1) {
      slider = new Flickity(track, {
        cellAlign: "left",
        contain: true,
        wrapAround: false,
        groupCells: true,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
      });
    }

    const prev = root.querySelector("[data-fc-ugc-prev]");
    const next = root.querySelector("[data-fc-ugc-next]");
    const updateArrows = () => {
      if (!slider) {
        prev.classList.add("fc-ugc__arrow--hidden");
        next.classList.add("fc-ugc__arrow--hidden");
        return;
      }
      prev.classList.toggle(
        "fc-ugc__arrow--hidden",
        slider.selectedIndex === 0,
      );
      next.classList.toggle(
        "fc-ugc__arrow--hidden",
        slider.selectedIndex >= slider.slides.length - 1,
      );
    };
    if (slider) {
      slider.on("select", updateArrows);
      prev.addEventListener("click", () => slider.previous());
      next.addEventListener("click", () => slider.next());
    }
    updateArrows();

    // Autoplay muted while visible, pause offscreen (saves battery/data)
    const videos = root.querySelectorAll("video");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.4 },
    );
    videos.forEach((video) => {
      video.muted = true;
      observer.observe(video);
    });

    // Sound toggle — one video with sound at a time
    root.querySelectorAll("[data-fc-ugc-sound]").forEach((button) => {
      const video = button.closest(".fc-ugc__cell").querySelector("video");
      if (!video) return;
      button.addEventListener("click", () => {
        const unmute = video.muted;
        if (unmute) {
          root.querySelectorAll("video").forEach((other) => {
            other.muted = true;
          });
          root.querySelectorAll("[data-fc-ugc-sound]").forEach((other) => {
            other.classList.remove("is-on");
            other.setAttribute("aria-pressed", "false");
            other.setAttribute("aria-label", "Geluid aan");
          });
        }
        video.muted = !unmute;
        button.classList.toggle("is-on", unmute);
        button.setAttribute("aria-pressed", String(unmute));
        button.setAttribute("aria-label", unmute ? "Geluid uit" : "Geluid aan");
      });
    });
  }

  initCopyCode() {
    // FC Promo Banner: tap the code chip to copy the discount code
    this.querySelectorAll(".fc-promo-banner__code").forEach((button) => {
      const label = button.querySelector(".fc-promo-banner__code-text");
      const originalLabel = label.textContent;
      let resetTimeout;

      button.addEventListener("click", async () => {
        const code = button.dataset.code;
        try {
          await navigator.clipboard.writeText(code);
        } catch (error) {
          // Clipboard API unavailable (older browsers / non-secure context)
          const helper = document.createElement("textarea");
          helper.value = code;
          helper.setAttribute("readonly", "");
          helper.style.position = "absolute";
          helper.style.left = "-9999px";
          document.body.appendChild(helper);
          helper.select();
          document.execCommand("copy");
          helper.remove();
        }

        button.classList.add("is-copied");
        label.textContent = button.dataset.copiedLabel || originalLabel;
        clearTimeout(resetTimeout);
        resetTimeout = setTimeout(() => {
          button.classList.remove("is-copied");
          label.textContent = originalLabel;
        }, 2000);
      });
    });
  }

  initBtnPriceListeners() {
    const quantitySelect = this.productForm.querySelector('select[name="quantity"]');
    const quantityInput = this.productForm.querySelector('input[name="quantity"]');

    if (quantitySelect) {
      quantitySelect.addEventListener("change", () => this.updateBtnPrice());
    }

    if (quantityInput) {
      quantityInput.addEventListener("input", () => this.updateBtnPrice());
    }
  }

  updateBtnPrice() {
    const btnPrice = this.querySelector(".ts-btn-price");
    if (!btnPrice) return;

    const variantPrice = parseInt(btnPrice.dataset.variantPrice, 10);
    const quantity = parseInt(
      this.productForm.querySelector("[name='quantity']").value,
    ) || 1;
    const totalPrice = variantPrice * quantity;

    const format = btnPrice.dataset.moneyFormat || "{{amount}}";
    const usesComma = format.includes("comma");
    const noDecimals = format.includes("no_decimals");
    const decimals = noDecimals ? 0 : 2;
    const locale = usesComma ? "de-DE" : "en-US";
    const formatted = Intl.NumberFormat(locale, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(totalPrice / 100);
    btnPrice.textContent = format.replace(/\{\{\s*(\w+)\s*\}\}/, formatted);
  }

  updateBtnVariantPrice(variant) {
    const btnPrice = this.querySelector(".ts-btn-price");
    if (!btnPrice || !variant) return;
    btnPrice.dataset.variantPrice = variant.price;
    this.updateBtnPrice();
  }
  
  initStickyCart() {
    const productForm = this.productForm;
    const stickyCart = document.querySelector(".sticky-add-to-cart");
    const stickyButton = document.querySelector("#StickyProductSubmit");
    const cartDrawer = document.querySelector("ts-cart");

    if (!productForm) {
      console.warn("Sticky cart: Product form not found");
      return;
    }

    if (!stickyCart) {
      console.warn("Sticky cart: Sticky cart element not found");
      return;
    }

    if (!stickyButton) {
      console.warn("Sticky cart: Sticky button not found");
      return;
    }

    // Track form visibility state
    let isFormVisible = true;
    let isCartDrawerOpen = false;

    // Function to show/hide sticky cart based on all conditions
    const updateStickyCartVisibility = () => {
      if (isCartDrawerOpen) {
        // Always hide when cart drawer is open
        stickyCart.classList.remove("show");
        document.body.classList.remove("sticky-add-to-cart--active");
      } else if (!isFormVisible) {
        // Show when form is not visible and drawer is closed
        stickyCart.classList.add("show");
        document.body.classList.add("sticky-add-to-cart--active");
      } else {
        // Hide when form is visible
        stickyCart.classList.remove("show");
        document.body.classList.remove("sticky-add-to-cart--active");
      }
    };

    // Update sticky cart price and variant when variant changes
    const updateStickyCartContent = () => {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      const priceElement = stickyCart.querySelector(
        ".sticky-add-to-cart__price--original",
      );
      const comparePriceElement = stickyCart.querySelector(
        ".sticky-add-to-cart__price--compare",
      );
      const variantDataScript = this.querySelector("#ProductVariants");

      // Get price from the main form's price display
      const mainPriceElement = this.querySelector(".ts-product__price");
      if (mainPriceElement) {
        const mainPriceOriginal = mainPriceElement.querySelector(
          ".ts-product__price--original",
        );
        const mainPriceCompare = mainPriceElement.querySelector(
          ".ts-product__price--compare",
        );

        if (mainPriceOriginal && priceElement) {
          priceElement.textContent = mainPriceOriginal.textContent.trim();
        }

        if (mainPriceCompare && comparePriceElement) {
          comparePriceElement.textContent = mainPriceCompare.textContent.trim();
          // Check if compare price is visible (not display:none or hidden)
          const compareStyle = window.getComputedStyle(mainPriceCompare);
          comparePriceElement.style.display =
            compareStyle.display !== "none" &&
            mainPriceCompare.offsetParent !== null
              ? "inline"
              : "none";
        } else if (comparePriceElement) {
          comparePriceElement.style.display = "none";
        }
      }

      // Update button state based on variant availability
      if (variantIdInput && variantDataScript) {
        try {
          const variants = JSON.parse(variantDataScript.textContent);
          const currentVariant = variants.find(
            (v) => v.id === parseInt(variantIdInput.value),
          );

          if (currentVariant) {
            // Find the first text span (not icon or loading)
            const buttonText = Array.from(
              stickyButton.querySelectorAll("span"),
            ).find(
              (span) =>
                !span.classList.contains("ts-icon") &&
                !span.classList.contains("ts-product__loading"),
            );
            if (currentVariant.available === false) {
              stickyButton.classList.add("disabled");
              stickyButton.disabled = true;
              if (buttonText) buttonText.textContent = "Uitverkocht";
            } else {
              stickyButton.classList.remove("disabled");
              stickyButton.disabled = false;
              if (buttonText) buttonText.textContent = "Toevoegen";
            }
          }
        } catch (error) {
          console.error("Error updating sticky cart content:", error);
        }
      }
    };

    // Use Intersection Observer to detect when form is out of view
    const observerOptions = {
      root: null,
      rootMargin: "-100px 0px 0px 0px", // Account for sticky cart height
      threshold: 0,
    };

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        isFormVisible = entry.isIntersecting;
        updateStickyCartVisibility();
      });
    };

    // Check if IntersectionObserver is supported
    if (typeof IntersectionObserver !== "undefined") {
      const observer = new IntersectionObserver(
        handleIntersection,
        observerOptions,
      );
      observer.observe(productForm);
    } else {
      // Fallback for browsers without IntersectionObserver support
      console.warn(
        "IntersectionObserver not supported, sticky cart may not work correctly",
      );
    }

    // Watch for cart drawer open/close
    if (cartDrawer) {
      const cartDrawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            isCartDrawerOpen = cartDrawer.classList.contains("open");
            updateStickyCartVisibility();
          }
        });
      });

      cartDrawerObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ["class"],
      });

      // Initial check
      isCartDrawerOpen = cartDrawer.classList.contains("open");
    }

    // Handle sticky button click
    stickyButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (!this.isLoading && !stickyButton.classList.contains("disabled")) {
        // Trigger form submit
        this.addToCart();
      }
    });

    // Update sticky cart image when variant changes
    const updateStickyCartImage = () => {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      const stickyImage = stickyCart.querySelector(
        ".sticky-add-to-cart__image",
      );
      const variantDataScript = this.querySelector("#ProductVariants");

      if (variantIdInput && variantDataScript && stickyImage) {
        try {
          const variants = JSON.parse(variantDataScript.textContent);
          const currentVariant = variants.find(
            (v) => v.id === parseInt(variantIdInput.value),
          );

          if (currentVariant && currentVariant.featured_image) {
            const imageUrl = new URL(
              currentVariant.featured_image.src,
              window.location.origin,
            );
            imageUrl.searchParams.set("width", "60");
            stickyImage.src = imageUrl.toString();
            const productTitle = this.querySelector(".ts-product__title");
            stickyImage.alt =
              currentVariant.featured_image.alt ||
              (productTitle ? productTitle.textContent : "") ||
              "";
          }
        } catch (error) {
          console.error("Error updating sticky cart image:", error);
        }
      }
    };

    // Update sticky cart when variant changes
    const variantInputs = this.querySelectorAll(
      '.ts-options input[type="radio"]',
    );
    variantInputs.forEach((input) => {
      input.addEventListener("change", () => {
        // Wait a bit for the price to update
        setTimeout(() => {
          updateStickyCartContent();
          updateStickyCartImage();
        }, 100);
      });
    });

    // Also listen for price updates (in case price is updated elsewhere)
    const priceObserver = new MutationObserver(() => {
      updateStickyCartContent();
    });

    const mainPriceElement = this.querySelector(".ts-product__price");
    if (mainPriceElement) {
      priceObserver.observe(mainPriceElement, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // Initial update
    updateStickyCartContent();
    updateStickyCartImage();
    updateStickyCartVisibility();
  }
}

customElements.define("ts-product", TSMainProduct)

function swapOpacity(childrens) {
  childrens.map((elem) => elem.style.opacity == '0' ? elem.style.opacity = '1' : elem.style.opacity = '0');
}
const animationDiv = document.querySelector('.fade-animation-child');
if(animationDiv && animationDiv.children){
  const childrens = Array.from(animationDiv.children);
  setInterval(() => swapOpacity(childrens), 3000);
}